var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04085 0.0825195C10.8851 0.0825195 13.9997 3.19708 13.9997 7.04129C13.9997 10.8855 10.8851 14.0001 7.04085 14.0001C3.1966 14.0001 0.0820312 10.8855 0.0820312 7.04129C0.0820312 3.19708 3.1966 0.0825195 7.04085 0.0825195Z",
    fill: "url(#paint0_linear_425_1681)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M12.2769 2.46699C11.2635 4.33167 9.82445 6.2504 8.03407 8.04076C6.2437 9.83112 4.3182 11.2634 2.46026 12.2836C2.3454 12.1822 2.23055 12.0741 2.12245 11.966C-0.640813 9.29739 -0.71513 4.88567 1.95355 2.12243C4.62222 -0.640807 9.03399 -0.715124 11.7972 1.95353C11.8513 2.00758 11.9053 2.06163 11.9662 2.12243C12.0743 2.23053 12.1824 2.34538 12.2837 2.46699H12.2769Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69118 3.37939H5.39418C4.27941 3.37939 3.38086 4.28471 3.38086 5.39271V8.68968C3.38086 9.80443 4.28617 10.703 5.39418 10.703H8.69118C9.80594 10.703 10.7045 9.79768 10.7045 8.68968V5.39271C10.7045 4.27795 9.79918 3.37939 8.69118 3.37939ZM10.0627 8.40592C10.0627 9.32475 9.3195 10.0679 8.40067 10.0679H5.68471C4.76587 10.0679 4.02268 9.32475 4.02268 8.40592V5.68997C4.02268 4.77115 4.76587 4.02797 5.68471 4.02797H8.40067C9.3195 4.02797 10.0627 4.77115 10.0627 5.68997V8.40592Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38018 5.72369L8.35991 5.70342L8.34641 5.6899C8.00184 5.34534 7.5289 5.14941 7.04246 5.14941C6.00201 5.15617 5.17102 6.00068 5.17778 7.04112C5.17778 7.54107 5.3737 8.02075 5.72502 8.37882C6.07634 8.73014 6.54926 8.93282 7.04246 8.92606C8.08966 8.9058 8.92066 8.03426 8.9004 6.98707C8.89364 6.51414 8.70447 6.06148 8.37342 5.71692L8.38018 5.72369ZM7.04246 8.28424C6.36009 8.29099 5.79258 7.74375 5.78582 7.06139C5.77907 6.37902 6.32631 5.81151 7.00868 5.80476C7.69105 5.798 8.25856 6.34524 8.26532 7.02761C8.26532 7.02761 8.26532 7.04112 8.26532 7.04787C8.26532 7.73024 7.72483 8.28424 7.04246 8.291V8.28424Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46167 5.06806C9.46167 5.31803 9.26574 5.51396 9.01576 5.52071C8.90091 5.52071 8.78606 5.47342 8.70499 5.39235C8.52933 5.21669 8.52933 4.92618 8.70499 4.75727C8.78606 4.6762 8.90091 4.62891 9.01576 4.62891C9.11711 4.62891 9.21846 4.66269 9.29953 4.73025H9.30627C9.30627 4.73025 9.3333 4.76403 9.34681 4.77754V4.79106C9.42113 4.87213 9.45491 4.97347 9.45491 5.07481L9.46167 5.06806Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_425_1681",
    x1: 1.91916,
    y1: 1.36543,
    x2: 11.7549,
    y2: 11.2013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAE100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FCB720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF7950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF1C74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C1CD1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaIcon);
export default __webpack_public_path__ + "static/media/instaIcon.f93e732668647eebce3a0006ab7b2d94.svg";
export { ForwardRef as ReactComponent };